export default {"src":"/_next/static/media/webgpt.c48de817.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};